import { useContext, useState } from 'react';
import { ShoppingCartContext } from '../../context/ShoppingCartContext';
import AaffCompuesto from './AaffCompuesto';
import AaffNoCompuesto from './AaffNoCompuesto';
import FooterCart from './FooterCart';
import { Backdrop, Paper, Stack, CircularProgress, Typography } from '@mui/material';
const CartContainer_v2 = () => {
  const { shoppingCart_v2, aaffCompuestos, aaffNoCompuestos } = useContext(ShoppingCartContext);
  const [isCreatingOrder, setIsCreatingOrder] = useState(false);

  if (
    !shoppingCart_v2 ||
    Object?.entries(shoppingCart_v2)?.length == 0 ||
    (Object?.entries(shoppingCart_v2)?.length == 0) == undefined
  )
    return (
      <div className="not-elements-container">
        <h2 style={{ textAlign: 'center' }}>No hay elementos en la cesta</h2>
      </div>
    );

  return (
    <div className="not-elements-container">
      <Backdrop
        open={isCreatingOrder}
        sx={{
          zIndex: (theme) => theme.zIndex.modal + 1,
          backgroundColor: 'rgba(51, 22, 22, 0.72)',
          backdropFilter: 'blur(2px)',
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: '100%',
            maxWidth: 560,
            mx: 2,
            px: 4,
            py: 5,
            textAlign: 'center',
          }}
        >
          <Stack spacing={2} alignItems="center">
            <CircularProgress size={36} />

            <Typography variant="h5" fontWeight={600}>
              Creando tu pedido
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              style={{
                marginTop: 2,
              }}
            >
              Esto tardará solo unos segundos.
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 440, lineHeight: 1.6 }}>
              Cuando termine, te enviaremos un correo con las instrucciones para completar la solicitud.
            </Typography>

            <Typography
              variant="body2"
              sx={{
                maxWidth: 440,
                lineHeight: 1.6,
                fontWeight: 600,
                color: 'warning.main',
              }}
            >
              Importante: debes seguir los pasos de ese correo para que la solicitud pueda tramitarse.
            </Typography>
          </Stack>
        </Paper>
      </Backdrop>

      <>
        {Object.entries(aaffCompuestos).map(([idPack, aaffCompuesto]) => (
          <AaffCompuesto key={idPack + aaffCompuesto.id} idPack={idPack} aaffCompuesto={aaffCompuesto} />
        ))}
        {aaffNoCompuestos.map((aaffNoCompuesto) => (
          <AaffNoCompuesto key={aaffNoCompuesto.id} aaffNoCompuesto={aaffNoCompuesto} />
        ))}
      </>

      <FooterCart isCreatingOrder={isCreatingOrder} setIsCreatingOrder={setIsCreatingOrder} />
    </div>
  );
};

export default CartContainer_v2;
